import { render, staticRenderFns } from "./payForChannelConfig.vue?vue&type=template&id=7b281e75&scoped=true"
import script from "./payForChannelConfig.vue?vue&type=script&lang=js"
export * from "./payForChannelConfig.vue?vue&type=script&lang=js"
import style0 from "./payForChannelConfig.vue?vue&type=style&index=0&id=7b281e75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b281e75",
  null
  
)

export default component.exports